<template>
 <h1>Oops!</h1>
 <h3>The apge you're looking for is not here.</h3>
 <router-link to="/">Back to the home page</router-link>
</template>

<script>
    export default {
    name: "NotFound",
    };
</script>
